import {popupUtil} from '@/helper/popup';
import RestrictedIP from '@/modules/register/componets/RestrictedIP.svelte';
import {userApi} from '@/api';
import {drawerUtil} from '@/helper/drawer';

export const StorageKey = 'restricted_modal_show_emails';

export async function openRestrictedIP({referralCode, LG, entrance, type, email}) {
  return await new Promise<boolean>(async (resolve, reject) => {
    const {data, reply} = await userApi.getPublicGeoV2(!referralCode ? {} : {extendInfo: JSON.stringify({referralCode})});
    const geo = data?.suggestionAction === 1;
    if (!geo) {
      if (reply?.data?.code === 31043 || (reply?.data?.code === 31029 && entrance === 'Register')) {
        drawerUtil.launchRegisterTips(LG);
        resolve(false);
        return;
      }
      resolve(true);
      return;
    }

    const emails = JSON.parse(localStorage.getItem(StorageKey) || '[]');
    if (type === 'email' && !!email && emails.includes(email)) {
      resolve(true);
      return;
    }

    const dialog = popupUtil.create(RestrictedIP, {...(reply?.data || {})});
    dialog.$on('close', () => {
      resolve(false);
    });
    dialog.$on('confirm', () => {
      if (type === 'email' && !!email && !emails.includes(email)) {
        emails.push(email);
        localStorage.setItem(StorageKey, JSON.stringify(emails));
      }
      resolve(true);
      dialog.$destroy();
    });
  });
}
